import { TRANSFER_ACTIONS } from "../../constants";

const initialState = {
    currentAssistedTransfer:undefined,
    currentBlindTransfer: undefined,
    showDataBySetting: false
}

const transferReducer = (state = initialState, action) => {
    switch (action.type) {
        case TRANSFER_ACTIONS.BLIND_TRANSFER:
            return { ...state, currentBlindTransfer: action.payload };
        case TRANSFER_ACTIONS.RESET_BLIND_TRANSFER:
            return { ...state, currentBlindTransfer: undefined };
        case TRANSFER_ACTIONS.ASSISTED_TRANSFER:
            return { ...state, currentAssistedTransfer: action.payload };
        case TRANSFER_ACTIONS.RESET_ASSISTED_TRANSFER:
            return { ...state, currentAssistedTransfer: undefined };
        case TRANSFER_ACTIONS.SHOW_DATA_TRANSGER_BY_SETTING:
            return {...state,showDataBySetting: action.payload}
        default:
            return state;
    }
}

export default transferReducer;


// WEBPACK FOOTER //
// ./src/redux/reducers/reducer_transfer.js